import React, { useEffect, useState } from 'react'
import { Box, Grid, Typography } from '@mui/material';
import Stack from "@mui/material/Stack";
import { Gauge } from "@mui/x-charts/Gauge";

const GradingModelView = ({ totalMarks, data, grades, gradeId }) => {

    const [details, setDetails] = useState();
    const [gradingModel, setGradingModel] = useState();
    useEffect(() => {
        if (grades) {
            const grading = grades?.find((grade) => grade?.id === gradeId
            );
            setGradingModel(grading);
            setDetails(grading?.details);
        }
    }, [gradeId])

    const calculatePercentage = (min, max, totalMarks) => {
        // Calculate the midpoint
        const midpoint = (parseInt(min) + parseInt(max)) / 2;
        const percentage = (midpoint / totalMarks) * 100;  // Percentage value
        return Math.round(percentage);  // Return the percentage as a number
    };

    return (
        <Box>
            <Typography variant="h5" align="center" sx={{ mb: 2, fontWeight: 600 }}>
                {gradingModel?.gradingModelName}
            </Typography>
            <Typography variant="h6" align="center" sx={{ mb: 2, fontWeight: 600 }}>
                Total Marks : <span style={{ background: '#FFB733', padding: '5px 10px', borderRadius: '10px' }}>{totalMarks}</span>
            </Typography>
            <Stack
                direction={{ xs: "column", md: "row" }}
                spacing={{ xs: 2, md: 3 }}
                justifyContent="center"
                alignItems="center"
                sx={{ flexWrap: "wrap", gap: 2 }}
            >
                {gradingModel?.details.map((grade, index) => {
                    const gradePercentage = calculatePercentage(grade.min, grade.max, totalMarks);
                    const gaugeValue = (gradePercentage / 100) * totalMarks; // Scale the value to fit the gauge
                    return (
                        <Box key={index} textAlign="center">
                            <Grid item xs={12}>
                                <Gauge
                                    width={70}
                                    height={70}
                                    value={gradePercentage}
                                    sx={{
                                        // Use the SVG 'path' element class to target the arc color
                                        "& .MuiGauge-valueArc": {
                                            fill: gradePercentage < 45 ? "red !important" : "#01e001 !important",  // Use 'fill' for color of the arc
                                        },
                                        "& .MuiGauge-backgroundArc": {
                                            fill: "lightgray",  // Optional: Color for background arc
                                        }
                                    }}
                                />
                                <Typography variant="h6" sx={{ mt: 1, fontWeight: 500 }}>
                                    {grade.gradeName}
                                </Typography>
                                <Typography variant="body2">
                                    {grade.max} - {grade.min}
                                </Typography>
                            </Grid>
                        </Box>
                    );
                })}
            </Stack>
        </Box>
    )
}

export default GradingModelView